var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerySad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 3.442C5.45912 3.442 3.4001 5.50281 3.4001 8.042C3.4001 10.5812 5.45912 12.642 8.0001 12.642C10.5412 12.642 12.6001 10.5831 12.6001 8.042C12.6001 5.50091 10.5412 3.442 8.0001 3.442ZM2.6001 8.042C2.6001 5.06119 5.01708 2.642 8.0001 2.642C10.983 2.642 13.4001 5.05908 13.4001 8.042C13.4001 11.0249 10.983 13.442 8.0001 13.442C5.01708 13.442 2.6001 11.0228 2.6001 8.042Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07067 5.85779C5.19118 5.67265 5.43897 5.62025 5.62412 5.74077L6.93612 6.59477C7.08453 6.69137 7.15176 6.87405 7.10137 7.04381C7.05099 7.21357 6.89499 7.33 6.71791 7.33H6.71391C6.61835 7.33 6.53061 7.29649 6.46181 7.24058L5.1877 6.41124C5.00255 6.29073 4.95015 6.04294 5.07067 5.85779Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28699 10.6408C8.5752 9.92905 7.42247 9.92905 6.71067 10.6408C6.55447 10.7971 6.3012 10.7971 6.14499 10.6408C5.98878 10.4846 5.98878 10.2314 6.14499 10.0752C7.1692 9.05095 8.82847 9.05095 9.85268 10.0752C10.0089 10.2314 10.0089 10.4846 9.85268 10.6408C9.69647 10.7971 9.4432 10.7971 9.28699 10.6408Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05081 6.70788C7.17348 6.89161 7.12399 7.13999 6.94026 7.26266L5.62826 8.13866C5.44453 8.26133 5.19615 8.21183 5.07348 8.02811C4.95081 7.84438 5.00031 7.596 5.18403 7.47333L6.49603 6.59733C6.67976 6.47466 6.92814 6.52416 7.05081 6.70788Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87063 6.83599C8.92108 6.66633 9.07704 6.55 9.25404 6.55H9.25804C9.35376 6.55 9.44163 6.58363 9.51049 6.63971L10.7846 7.471C10.9696 7.59171 11.0218 7.83956 10.901 8.02457C10.7803 8.20959 10.5325 8.26172 10.3475 8.14101L9.03547 7.28501C8.88723 7.18829 8.82018 7.00565 8.87063 6.83599Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8989 5.85424C11.0214 6.03809 10.9717 6.28642 10.7878 6.4089L9.47581 7.2829C9.29195 7.40537 9.04362 7.35562 8.92115 7.17176C8.79867 6.98791 8.84843 6.73958 9.03228 6.6171L10.3443 5.7431C10.5281 5.62062 10.7765 5.67038 10.8989 5.85424Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerySad);
export default __webpack_public_path__ + "static/media/verySad.d7708806903628c5a28a472dfe33c80f.svg";
export { ForwardRef as ReactComponent };